<template>
  <section class="home-block home-procurement">
    <div class="home-block__inner">
      <div class="home-block__head">
        <div class="home-block__titleBox">
          <h2 class="home-block__title">招采信息</h2>
          <div class="home-block__entitle">PROCUREMENT INFORMATION</div>
        </div>
        <div class="home-block__setting">
          <div class="home-block__toPurchase" @click="toProcurementCenter">
            前往招采中心>
          </div>
          <div class="home-block__pagination">
            <img src="@/assets/image/home/prevIcon.png" @click="checkPrev()" alt="" />
            <img src="@/assets/image/home/nextIcon.png" @click="checkNext()" alt="" />
          </div>
        </div>
      </div>
      <div class="home-block__body">
        <div class="home-block__procurement">
          <div class="push_box" :style="{
            backgroundImage: `url(${pushBg})`,
            backgroundSize: 'cover',
          }">
            <div class="push_top" @click="toPushProcurement">
              <div class="push_titleBox">
                <div class="push_title">发布招采单</div>
                <div class="push_titleEn">Issue the procurement order</div>
              </div>
              <img src="@/assets/image/home/toIcon.png" alt="" />
            </div>
            <div class="push_item" v-for="(item, index) in pushData" :key="index">
              <div class="item_title">{{ item.title }}</div>
              <img v-if="index !== 3" :src="stepIcon" alt="" />
            </div>
          </div>
          <el-card v-for="(item, index) in procurementList" :key="index" class="procurement_item"
            @click.native="toProcurementDetail(item)">
            <el-tag :class="item.type === 1 ? 'tag1' : 'tag2'">{{
              item.type === 1 ? "物资采购" : "运力采购"
            }}</el-tag>
            <div class="item_title">{{ item.theTitle }}</div>
            <div class="item_infoBox">
              <div class="item_info">
                <img class="info_img" src="@/assets/image/home/personIcon.png" alt="" />
                <!-- <span class="info_title">买家名称：</span> -->
                <span class="info_content" v-if="!getToken()">买家名称：*******</span>
                <span class="info_content" v-else-if="(isAuthSeller() && item.type === 1) || (isAuthLogistics() && item.type === 2)">买家名称：{{ item.companyName }}</span>
                <span class="info_content can_not_see" v-else>买家名称：{{
                  item.type === 1 ? "认证卖家后可查看买家名称" : "认证物流商后可查看买家名称" }}</span>
              </div>
              <div class="item_info">
                <img class="info_img" src="@/assets/image/home/timeIcon.png" alt="" />
                <!-- <span class="info_title">发布时间：</span> -->
                <span class="info_content">发布时间：{{ item.createTime }}</span>
              </div>
              <div class="item_info">
                <img class="info_img" src="@/assets/image/home/descIcon.png" alt="" />
                <!-- <span class="info_title">概要说明：</span> -->
                <span class="info_content">概要说明：{{ item.summaryDesc }}</span>
              </div>
            </div>
            <div class="item_statusBox">
              <div class="status_title">
                <div :class="item.theStatus === 0
                  ? 'circle0'
                  : item.theStatus === 1
                    ? 'circle1'
                    : item.theStatus === 2
                      ? 'circle2'
                      : item.theStatus === 3
                        ? 'circle3'
                        : 'circle4'
                  "></div>
                <div :class="item.theStatus === 0
                  ? 'status_text0'
                  : item.theStatus === 1
                    ? 'status_text1'
                    : item.theStatus === 2
                      ? 'status_text2'
                      : item.theStatus === 3
                        ? 'status_text3'
                        : 'status_text4'
                  ">
                  {{
                    item.theStatus === 0
                      ? "即将开始"
                      : item.theStatus === 1
                        ? "进行中"
                        : item.theStatus === 2
                          ? "已结束"
                          : item.theStatus === 3
                            ? "已评标"
                            : "已取消"
                  }}
                </div>
              </div>
              <div class="status_content" v-if="item.status === 1">
                剩余时间：{{ getRemainingTimeStr(item.offerTimeEnd) }}
              </div>
            </div>
          </el-card>
          <slot v-if="procurementList.length === 0">
            <div class="home-block__empty">暂无数据</div>
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getPurchase } from "@/api/home";
import { getToken } from "@/utils/auth";
export default {
  name: "HomeProcurement",
  data() {
    return {
      pushBg: require("@/assets/image/home/pushProcurement_bg.png"),
      stepIcon: require("@/assets/image/home/stepIcon.png"),
      pushData: [
        {
          title: "发布招采需求",
        },
        {
          title: "供应商报名响应",
        },
        {
          title: "评审与结果公示",
        },
        {
          title: "签订合同归档",
        },
      ],
      loading: false,
      procurementData: [],
      procurementList: [],
      page: {
        size: 3,
        current: 1,
        total: 0,
      },
      timer: null, // 定时器
      now: Date.now(), // 当前时间戳，用于触发视图更新
    };
  },
  computed: {
    // 计算总页数
    totalPages() {
      if (this.page.total === 0) return 0;
      return Math.ceil(this.page.total / this.page.size);
    },
  },
  mounted() {
    this.getProcurementData();
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  created() { },
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    getToken,
    async getProcurementData() {
      this.loading = true;
      const res = await getPurchase();
      this.loading = false;
      if (res.data != null) {
        this.procurementData = res.data;
        this.page.total = this.procurementData.length;
        // 初始化第一页数据
        this.updateCurrentPageData();
      } else {
        this.procurementData = [];
        this.procurementList = [];
      }
    },
    updateCurrentPageData() {
      const start = (this.page.current - 1) * this.page.size;
      const end = start + this.page.size;
      //  slice 不会修改原数组，返回新数组
      this.procurementList = this.procurementData.slice(start, end);
    },
    // 前往招采中心
    toProcurementCenter() {
      this.$router.push({
        path: "/Procurement",
      });
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    // 上一页
    checkPrev() {
      if (this.page.current > 1) {
        this.page.current--;
        this.updateCurrentPageData();
      }
    },
    // 下一页
    checkNext() {
      if (this.page.current < this.totalPages) {
        this.page.current++;
        this.updateCurrentPageData();
      }
    },
    getRemainingTimeStr(endTimeStr) {
      if (!endTimeStr) return "--";
      // 假设 endTimeStr 格式为 "yyyy-MM-dd HH:mm:ss" 或时间戳
      // 如果是字符串，需要转换为时间戳
      const endTime = new Date(endTimeStr).getTime();
      const currentTime = this.now; // 使用响应式的 now
      const diff = endTime - currentTime;
      // 如果已经结束
      if (diff <= 0) {
        return "已结束";
      }
      // 计算时分秒
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      // 补零格式化
      const h = hours.toString().padStart(2, "0");
      const m = minutes.toString().padStart(2, "0");
      const s = seconds.toString().padStart(2, "0");
      return `${h}:${m}:${s}`;
    },
    // 查看详情
    toProcurementDetail(item) {
      if (getToken()) {
        console.log("已登录");
        // 判断是否实名认证
        if (this.isAuth()) {
          // 判断是否有卖家身份和物流商身份
          if ((this.isAuthSeller() && item.type === 1) || (this.isAuthLogistics() && item.type === 2)) {
            this.linkJump("/procurement/procurementDetail", { id: item.id });
          } else {
            if (item.type === 1) {
              this.linkJump("/tradersCenter", { needCertification: "seller" });
            } else if (item.type === 2) {
              this.linkJump("/tradersCenter", { needCertification: "logistics" });
            }
          }
        } else {
          this.changeAuthVisible(true);
          console.log("未认证", this.$store.state.certVisible);
          return;
        }
      } else {
        this.linkJump("/procurement/procurementDetail", { id: item.id });
      }
    },

    // 前往发布招采
    toPushProcurement() {
      console.log("发布求购单");
      // 校验是否登录
      if (getToken()) {
        console.log("已登录");
        // 判断是否实名认证
        if (this.isAuth()) {
          // 判断是否有买家身份
          if (this.isAuthBuyer()) {
            this.linkJump("/procurement/procurementDeal");
          } else {
            this.linkJump("/tradersCenter", { needCertification: "buyer" });
          }
        } else {
          this.changeAuthVisible(true);
          console.log("未认证", this.$store.state.certVisible);
          return;
        }
      } else {
        this.linkJump("/procurement/procurementDeal");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";

.home-block {
  width: 100%;
  background: #ffffff;
  font-family: Source Han Sans CN, Source Han Sans CN;

  &__inner {
    width: @defaultWidth;
    margin: 0 auto;
    padding: 32px 0;
  }

  &__head {
    margin-bottom: 20px;
    padding-bottom: 12px;
    // border-bottom: 2px solid #3b75dd;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    // min-width: 120px;
  }

  &__titleBox {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &__title {
    font-weight: 500;
    font-size: 36px;
    color: #323233;
  }

  &__entitle {
    font-weight: 400;
    font-size: 22px;
    color: #cccccc;
  }

  &__setting {
    font-weight: 400;
    font-size: 14px;
    color: #3b75dd;
    display: flex;
    align-items: center;
  }

  &__toPurchase {
    font-weight: 400;
    font-size: 14px;
    color: #3b75dd;
    cursor: pointer;
  }

  &__pagination {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 40px;

    img {
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }

  &__body {
    min-height: 120px;
  }

  &__procurement {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .push_box {
    width: 355px;
    height: 361px;
    box-sizing: border-box;
    padding: 24px 30px;

    .push_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .push_titleBox {
        .push_title {
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
        }

        .push_titleEn {
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          margin-top: 5px;
        }
      }

      img {
        width: 37px;
        height: 37px;
        cursor: pointer;
      }
    }

    .push_item {
      text-align: center;

      img {
        width: 20px;
        height: 20px;
        margin: 5px 0;
      }

      .item_title {
        height: 40px;
        background: rgba(255, 255, 255, 0.16);
        border-radius: 2px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        text-align: center;
        line-height: 40px;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  .procurement_item {
    flex: 1;
    height: 361px;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 10px 10px 0 10px;
    cursor: pointer;
    position: relative;

    .tag1 {
      width: 76px;
      height: 28px;
      background: #ff954f;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      border: none;
    }

    .tag2 {
      width: 76px;
      height: 28px;
      background: #ff6d70;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      border: none;
    }

    .item_title {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 26px;
      margin: 14px 0 30px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      /* 限制行数为2 */
      overflow: hidden;
    }

    // 信息盒子
    .item_infoBox {
      display: flex;
      flex-wrap: wrap;
    }

    .item_info {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;

      .info_img {
        width: 19px;
        height: 19px;
        margin-right: 6px;
      }

      .info_content {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        /* 限制行数为2 */
        overflow: hidden;
      }
    }

    .item_statusBox {
      width: calc(100% - 60px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 20px;
      border-top: 1px solid #f0f0f0;
      margin-top: 10px;
      position: absolute;
      bottom: 20px;

      .status_title {
        display: flex;
        align-items: center;
        gap: 5px;

        .circle0 {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #ff8d28;
        }

        .circle1 {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #3b75dd;
        }

        .circle2 {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #999999;
        }

        .circle3 {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #34c759;
        }

        .circle4 {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #ff6d70;
        }

        .status_text0 {
          font-weight: 400;
          font-size: 14px;
          color: #ff8d28;
        }

        .status_text1 {
          font-weight: 400;
          font-size: 14px;
          color: #3b75dd;
        }

        .status_text2 {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }

        .status_text3 {
          font-weight: 400;
          font-size: 14px;
          color: #34c759;
        }

        .status_text4 {
          font-weight: 400;
          font-size: 14px;
          color: #ff6d70;
        }
      }

      .status_content {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }

  &__empty {
    width: 100%;
    padding: 40px 0;
    text-align: center;
    color: #c0c4cc;
    font-size: 14px;
  }
}
</style>
